import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=d8517222&scoped=true"
import script from "./Badge.vue?vue&type=script&lang=js"
export * from "./Badge.vue?vue&type=script&lang=js"
import style0 from "./Badge.vue?vue&type=style&index=0&id=d8517222&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8517222",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8517222')) {
      api.createRecord('d8517222', component.options)
    } else {
      api.reload('d8517222', component.options)
    }
    module.hot.accept("./Badge.vue?vue&type=template&id=d8517222&scoped=true", function () {
      api.rerender('d8517222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Badge.vue"
export default component.exports